<template>
<div>
    <CRow>
        <CCol col="12" md="6" class="mx-auto">
            <CCard class="py-md-4">
                <CCardBody>
                    <FaIcon :icon="icon.icon" :class="icon.class" />
                    <p class="text-center mt-4 payment-message">{{ message }}</p>
                    <p v-if="result.status === 'OK'" class="text-center text-muted text-small">
                        {{ $t('transaction.your_account_charged', {amount: result.transaction.amount}) }}
                    </p>
                </CCardBody>
            </CCard>
        </CCol>
        <CCol col="12" class="text-center">
            <CButton :to="{name: 'transactions'}" color="affili-indigo">
                {{ $t('transaction.see_transactions') }}
            </CButton>
        </CCol>
    </CRow>
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ChargeAccountResponse',

    data() {
        return {
            result: {
                status: 'unkown',
                transaction: {
                    id: 0,
                    amount: 0,
                },
                is_first_charge: false,
            },
        }
    },

    computed: {
        icon() {
            const icons = {
                OK: {
                    icon: 'check-circle',
                    class: 'font-5xl d-block mx-auto text-success'
                },
                NOK: {
                    icon: 'times-circle',
                    class: 'font-5xl d-block mx-auto text-danger'
                },
                duplicate: {
                    icon: 'exclamation-circle',
                    class: 'font-5xl d-block mx-auto text-affili-coral'
                },
                unkown: {
                    icon: 'question-circle',
                    class: 'font-5xl d-block mx-auto text-black-50'
                }
            }

            return icons[this.result.status]
        },
        message() {
            const messages = {
                OK: this.$t('transaction.success_payment'),
                NOK: this.$t('transaction.fail_payment'),
                duplicate: this.$t('transaction.duplicate_payment'),
                unkown: this.$t('transaction.unkown_payment'),
            }

            return messages[this.result.status]
        },
    },

    // watch: {
    //     'result.status'(value) {
    //         if(value === 'OK' && this.result.is_first_charge) {
    //             this.$affiliJs.conversion(this.result.transaction.id, this.result.transaction.amount, 'chargeAccount')
    //         }
    //     }
    // },

    methods: {
        ...mapActions({
            verify: 'transaction/verify'
        })
    },

    created() {
        this.verify(this.$route.query).then(result => this.result = result.data)
    },
}
</script>

<style lang="scss" scoped>
.payment-message {
    font-size: 18px;
}
</style>